import video1 from './1.mp4';
import video2 from './2.mp4';
import video3 from './3.mp4';
import video4 from './4.mp4';
import video5 from './5.mp4';
import video6 from './6.mp4';
import video7 from './7.mp4';
import video8 from './8.mp4';
import video9 from './9.mp4';
import video10 from './10.mp4';
import video11 from './11.mp4';
import video12 from './12.mp4';
import video13 from './13.mp4';
import video14 from './14.mp4';
import video15 from './15.mp4';
import video16 from './16.mp4';
import video17 from './17.mp4';
import video18 from './18.mp4';
import video19 from './19.mp4';
import video20 from './20.mp4';
import video21 from './21.mp4';
import video22 from './22.mp4';
import video23 from './23.mp4';
import video24 from './24.mp4';
import video25 from './25.mp4';
import video26 from './26.mp4';
import video27 from './27.mp4';
import video28 from './28.mp4';
import video29 from './29.mp4';
import video30 from './30.mp4';
import video31 from './31.mp4';
import video32 from './32.mp4';
import video33 from './33.mp4';
import video34 from './34.mp4';
import video35 from './35.mp4';
import video36 from './36.mp4';

export const videoList = [
  {
    title: 'Animation 1',
    src: video1,
  },
  {
    title: 'Animation 2',
    src: video2,
  },
  {
    title: 'Animation 3',
    src: video3,
  },
  {
    title: 'Animation 4',
    src: video4,
  },
  {
    title: 'Animation 5',
    src: video5,
  },
  {
    title: 'Animation 6',
    src: video6,
  },
  {
    title: 'Animation 7',
    src: video7
  },
  {
    title: 'Animation 8',
    src: video8,
  },
  {
    title: 'Animation 9',
    src: video9,
  },
  {
    title: 'Animation 10',
    src: video10,
  },
  {
    title: 'Animation 11',
    src: video11,
  },
  {
    title: 'Animation 12',
    src: video12,
  },
  {
    title: 'Animation 13',
    src: video13,
  },
  {
    title: 'Animation 14',
    src: video14,
  },
  {
    title: 'Animation 15',
    src: video15,
  },
  {
    title: 'Animation 16',
    src: video16,
  },
  {
    title: 'Animation 17',
    src: video17,
  },
  {
    title: 'Animation 18',
    src: video18,
  },
  {
    title: 'Animation 19',
    src: video19,
  },
  {
    title: 'Animation 20',
    src: video20,
  },
  {
    title: 'Animation 21',
    src: video21,
  },
  {
    title: 'Animation 22',
    src: video22,
  },
  {
    title: 'Animation 23',
    src: video23,
  },
  {
    title: 'Animation 24',
    src: video24,
  },
  {
    title: 'Animation 25',
    src: video25,
  },
  {
    title: 'Animation 26',
    src: video26,
  },
  {
    title: 'Animation 27',
    src: video27,
  },

  {
    title: 'Animation 28',
    src: video28,
  },

  {
    title: 'Animation 29',
    src: video29,
  },
  {
    title: 'Animation 30',
    src: video30,
  },
  {
    title: 'Animation 31',
    src: video31,
  },
  {
    title: 'Animation 32',
    src: video32,
  },
  {
    title: 'Animation 33',
    src: video33,
  },
  {
    title: 'Animation 34',
    src: video34,
  },
  {
    title: 'Animation 35',
    src: video35,
  },
  {
    title: 'Animation 36',
    src: video36,
  },
];

export default videoList;
